import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';

export const StyledBox = styled(Box)`
  word-break: break-word;
`;

StyledBox.displayName = 'StyledBox';
